// extracted by mini-css-extract-plugin
export default {"resizableTitleOverlay":"ResizableTitle_resizableTitleOverlay__IXvVW"};